<template>
    <section style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    ">
        <!-- Bouton d'ajout -->
        <v-row>
            <v-col cols="12" sm="12" md="6">
                <v-row>
                    <v-col cols="12" sm="12" md="4">
                        <v-btn @click="addCard = !addCard" class="info ml-6 mr-2 mt-4">
                            <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
                            {{ addCard ? "Fermer le formulaire" : "Ajouter un nouveau Tag" }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <!-- Formulaire d'Ajout (Affiché si addCard = true) -->
        <v-row v-if="addCard">
            <v-col cols="12">
                <v-card class="mb-6 ml-6 mr-2 mt-4 pa-4 elevation-2">
                    <v-card-title class="font-weight-bold">Ajouter un nouveau Tag</v-card-title>
                    <v-form ref="addForm" v-model="isAddValid" lazy-validation>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field v-model="newTag.title" label="Titre (FR) *"
                                        placeholder="Ex: Événement" outlined dense :rules="rules.title"
                                        required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field v-model="newTag.titleEn" label="Titre (EN) *" placeholder="Ex: Event"
                                        outlined dense :rules="rules.titleEn" required></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions class="px-4">
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="resetAddForm" :disabled="loadingAdd">
                                Annuler
                            </v-btn>
                            <v-btn color="info" @click="createTag" :loading="loadingAdd" :disabled="!isAddValid">
                                Enregistrer
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="mb-6 ml-6 mt-6 mr-2">
            <v-card-title>
                Liste des Tags
                <v-spacer></v-spacer>
            </v-card-title>

            <v-data-table :headers="headers" :items="tagsArray" :loading="isLoadingTables"
                loading-text="Chargement des données..." class="elevation-1" item-key="id" :footer-props="{
                    'items-per-page-options': [5, 10, 15, 30],
                }">
                <template v-slot:[`item.modifier`]="{ item }">
                    <v-icon @click="editTag(item)">
                        {{ icons.mdiPencil }}
                    </v-icon>
                </template>

                <template v-slot:[`item.supprimer`]="{ item }">
                    <v-icon @click="deleteTag(item)">
                        {{ icons.mdiDeleteOutline }}
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialogEdit" max-width="600px" persistent>
            <v-card>
                <v-card-title class="headline font-weight-bold">
                    Modifier le Tag #{{ tagToEdit.id }}
                </v-card-title>

                <v-form ref="editForm" v-model="isEditValid" lazy-validation>
                    <v-card-text class="pt-4">
                        <v-row>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="tagToEdit.title" label="Titre (FR) *" outlined dense
                                    :rules="rules.title" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="tagToEdit.titleEn" label="Titre (EN) *" outlined dense
                                    :rules="rules.titleEn" required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="px-4 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click="dialogEdit = false" :disabled="loadingEdit">
                            Annuler
                        </v-btn>
                        <v-btn color="info" @click="updateTag" :loading="loadingEdit" :disabled="!isEditValid">
                            Sauvegarder
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="text-h6">
                    Confirmation de suppression
                </v-card-title>
                <v-card-text class="pt-2">
                    Êtes-vous sûr de vouloir supprimer le tag :
                    <strong>"{{ tagToDelete.title }}"</strong>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="grey darken-1" @click="dialogDelete = false" :disabled="loadingDelete">
                        Annuler
                    </v-btn>
                    <v-btn color="error" @click="confirmDeleteTag" :loading="loadingDelete">
                        Supprimer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Notification Snackbar -->
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout"
            :top="snackbar.position === 'top'">




            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.visible = false">
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>
    </section>
</template>

<script>
import {
    mdiDatabasePlusOutline,
    mdiMagnify,
    mdiPencil,
    mdiDeleteOutline,
} from '@mdi/js';
import Constant from "@/utils/constants";
import axios from 'axios';
import { FetchAllTags } from '@/views/qorani/services/services';

export default {
    data() {
        return {
            // État formulaire d'ajout
            addCard: false,
            isAddValid: true,
            loadingAdd: false,
            newTag: {
                title: '',
                titleEn: '',
            },

            isLoadingTables: false,
            tagsArray: [],
            headers: [
                { text: "ID", value: "id", width: "100px", align: "start" },
                { text: "Titre", value: "title", align: "start" },
                { text: "Titre (EN)", value: "titleEn", align: "start" },
                { text: "Modifier", value: "modifier", align: "center", sortable: false, width: "100px" },
                { text: "Supprimer", value: "supprimer", align: "center", sortable: false, width: "100px" },
            ],

            // Modification
            dialogEdit: false,
            isEditValid: true,
            loadingEdit: false,
            tagToEdit: {
                id: null,
                title: '',
                titleEn: '',
            },

            // Suppression
            dialogDelete: false,
            loadingDelete: false,
            tagToDelete: {
                id: null,
                title: '',
                titleEn: '',
            },

            // Règles de validation
            rules: {
                title: [(v) => !!v || "Le titre (FR) est requis"],
                titleEn: [(v) => !!v || "Le titre (EN) est requis"],
            },

            // Notification Snackbar
            snackbar: {
                visible: false,
                text: '',
                color: 'success',
                timeout: 3000,
            },

            // Icônes
            icons: {
                mdiDatabasePlusOutline,
                mdiMagnify,
                mdiPencil,
                mdiDeleteOutline,
            },
        }
    },
    methods: {
        async fetchAllTags() {
            this.isLoadingTables = true;
            try {
                this.tagsArray = await FetchAllTags() || [];
            } catch (error) {
                console.error("Erreur lors de la récupération des tags:", error);
                this.showSnackbar("Erreur lors du chargement des tags", "error");
            } finally {
                this.isLoadingTables = false;
            }
        },


        async createTag() {
            if (!this.$refs.addForm.validate()) return;

            this.loadingAdd = true;
            try {
                const payload = {
                    title: this.newTag.title,
                    titleEn: this.newTag.titleEn,
                };
                const response = await axios.post(`${Constant.QORANI}tag/add`, payload);

                this.showSnackbar("Tag ajouté avec succès !", "success");
                this.resetAddForm();
                this.addCard = false;
                await this.fetchAllTags();
            } catch (error) {
                console.error("Erreur lors de l'ajout du tag:", error);
                this.showSnackbar(
                    error?.response?.data?.message || "Erreur lors de l'ajout du tag",
                    "error"
                );
            } finally {
                this.loadingAdd = false;
            }
        },

        resetAddForm() {
            this.newTag = { title: '', titleEn: '' };
            if (this.$refs.addForm) {
                this.$refs.addForm.resetValidation();
            }
            this.addCard = false;
        },

        editTag(item) {
            this.tagToEdit = { ...item };
            this.dialogEdit = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.resetValidation();
                }
            });
        },

        async updateTag() {
            if (!this.$refs.editForm.validate()) return;

            this.loadingEdit = true;
            try {
                const payload = {
                    title: this.tagToEdit.title,
                    titleEn: this.tagToEdit.titleEn,
                };
                const response = await axios.post(`${Constant.QORANI}tag/edit/${this.tagToEdit.id}`, payload);

                this.showSnackbar("Tag modifié avec succès !", "success");
                this.dialogEdit = false;
                await this.fetchAllTags();
            } catch (error) {
                console.error("Erreur lors de la modification du tag:", error);
                this.showSnackbar(
                    error?.response?.data?.message || "Erreur lors de la modification du tag",
                    "error"
                );
            } finally {
                this.loadingEdit = false;
            }
        },

        // ==========================================
        // 4. DELETE (Suppression d'un tag)
        // ==========================================
        deleteTag(item) {
            this.tagToDelete = { ...item };
            this.dialogDelete = true;
        },

        async confirmDeleteTag() {
            this.loadingDelete = true;
            try {
                const response = await axios.get(`${Constant.QORANI}tag/delete/${this.tagToDelete.id}`);

                this.showSnackbar("Tag supprimé avec succès !", "success");
                this.dialogDelete = false;
                await this.fetchAllTags();
            } catch (error) {
                console.error("Erreur lors de la suppression du tag:", error);
                this.showSnackbar(
                    error?.response?.data?.message || "Erreur lors de la suppression du tag",
                    "error"
                );
            } finally {
                this.loadingDelete = false;
            }
        },

        showSnackbar(text, color = 'success') {
            this.snackbar.text = text;
            this.snackbar.color = color;
            this.snackbar.visible = true;
        },
    },
    async created() {
        await this.fetchAllTags();
    },
}
</script>

<style scoped></style>
